import { createRouter, createWebHashHistory } from 'vue-router'
import PageImageEditor from '@/views/PageImageEditor/Index.vue'

const routes = [
  { path: '/', component: PageImageEditor },
  { path: '/watermark-config', component: () => import('@/views/PageWatermarkConfig/Index.vue') },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
